import React, { createContext, useReducer } from 'react'
import { getUserId } from '@futures-platform/connectors/session'
import { ACTIONS } from './Actions'
import reducers from './Reducers.js'

const initialState = {
  cmtsData: [],
  contentData: {},
  contentSettings: {},
  contentTypes: [],
  groupRadarIdGlobalState: null,
  tags: [],
  devPaths: [],
  isMainActorsDeactivated: false,
  isRelatedScenariosDeactivated: false,
  isTagsDeactivated: false,
  scenarioSet: null,
  scenario: null,
}

export const DataContext = createContext(initialState)

export const DataProvider = ({ children, gid, ssid, sid }) => {
  const [state, dispatch] = useReducer(reducers, initialState)

  return (
    /* eslint-disable */
    <>
      <DataContext.Provider value={{ state, dispatch }}>
        {children}
      </DataContext.Provider>
    </>
  )
}
